export function stopEvent(event) {
	if (event) {
		event.stopPropagation();
		event.preventDefault();
	}
}



// WEBPACK FOOTER //
// ./src/utils/event.js